import React, { useState, useRef } from 'react';
import styles from './UserOtpVari.module.css';
import { useNavigate, useParams } from "react-router-dom";

export default function UserOtpVari({ onVerify }) {
  const navigate = useNavigate();
    const { userId, deviceUuid } = useParams();
  
    const basePath =
      userId && deviceUuid
        ? `/${userId}/${deviceUuid}`
        : "";
  
    const goTo = (path) => {
      navigate(
        basePath
          ? `${basePath}${path}`
          : path
      );
    };
  
  const [otp, setOtp] = useState(['', '', '', '']);
  const inputRefs = [useRef(null), useRef(null), useRef(null), useRef(null)];

  // Auto-focus next input on digit entry
  const handleChange = (index, e) => {
    const value = e.target.value;
    if (isNaN(Number(value))) return;

    const newOtp = [...otp];
    newOtp[index] = value.substring(value.length - 1);
    setOtp(newOtp);

    // Focus next box
    if (value && index < 3) {
      inputRefs[index + 1].current.focus();
    }
  };

  // Handle backspace navigation
  const handleKeyDown = (index, e) => {
    if (e.key === 'Backspace' && !otp[index] && index > 0) {
      inputRefs[index - 1].current.focus();
    }
  };

  // Handle paste functionality
  const handlePaste = (e) => {
    e.preventDefault();
    const pasteData = e.clipboardData.getData('text').trim().slice(0, 4);
    if (!/^\d+$/.test(pasteData)) return;

    const newOtp = [...otp];
    pasteData.split('').forEach((char, i) => {
      if (i < 4) newOtp[i] = char;
    });
    setOtp(newOtp);

    const focusIndex = Math.min(pasteData.length, 3);
    inputRefs[focusIndex].current.focus();
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const otpValue = otp.join('');
    if (otpValue.length < 4) {
      alert('Please enter a complete 4-digit OTP.');
      return;
    }
    if (onVerify) {
      onVerify(otpValue);
    }
  };

  return (
    <div className={styles.screenWrapper}>
      <div className={styles.deviceFrame}>
        <div className={styles.scrollContainer}>
          
          <main className={styles.contentSection}>
            {/* Header Typography */}
            <div className={styles.headerGroup}>
              <h1 className={styles.title}>OTP Verification</h1>
              <p className={styles.subtitle}>
                The OTP was sent to Prathamesh Dolaskar<br />
                on his dhoond app.
              </p>
            </div>

            {/* OTP Input Form */}
            <form onSubmit={handleSubmit} className={styles.formContainer}>
              <div className={styles.otpBoxContainer} onPaste={handlePaste}>
                {otp.map((digit, index) => (
                  <input
                    key={index}
                    ref={inputRefs[index]}
                    type="text"
                    inputMode="numeric"
                    maxLength="1"
                    value={digit}
                    onChange={(e) => handleChange(index, e)}
                    onKeyDown={(e) => handleKeyDown(index, e)}
                    className={`${styles.otpInput} ${digit ? styles.hasValue : ''}`}
                    aria-label={`Digit ${index + 1}`}
                  />
                ))}
              </div>

              {/* Action Button */}
              <button type="submit" className={styles.verifyBtn}>
                Verify OTP
              </button>
            </form>
          </main>

        </div>
      </div>
    </div>
  );
}